<script setup lang="ts">
import BtnAppGallery from '@features/apps/assets/app-gallery-badge.webp'
import BtnApple from '@features/apps/assets/app-store-badge.webp'
import BtnGoogle from '@features/apps/assets/google-play-badge.webp'
import { APPMETRICA_SERVE } from '@features/apps/constants'

const APPS_LINKS = [
  {
    key: 'Apple',
    href: APPMETRICA_SERVE.apple,
    image: BtnApple,
  },
  {
    key: 'Google',
    href: APPMETRICA_SERVE.google,
    image: BtnGoogle,
  },
  {
    key: 'AppGallery',
    href: APPMETRICA_SERVE.huawei,
    image: BtnAppGallery,
  },
]
</script>

<template>
  <div class="apps-buttons">
    <nuxt-link
      v-for="link in APPS_LINKS"
      :key="link.key"
      :href="link.href"
      target="_blank"
      variant="transparent"
      class="apps-buttons__link"
    >
      <nuxt-img class="apps-buttons__image" :src="link.image" :alt="link.key" />
    </nuxt-link>
  </div>
</template>

<style scoped lang="scss">
.apps-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 13px;

  &__link {
    width: 103px;
    height: 32px;
    color: var(--ui-text-primary);
  }

  &__image {
    width: 100%;
    height: 100%;
  }

  @include media($bp-tablet) {
    gap: 24px;

    &__link {
      width: 128px;
      max-width: 150px;
      height: 47px;
    }
  }

  @include media($bp-desktop-mini) {
    flex-wrap: nowrap;

    &__link {
      width: 128px;
      max-width: none;
      height: 40px;
    }
  }
}
</style>
